export default __webpack_public_path__ + "assets/images/3193bd0d2af10246af5cdbb9ebb78d90.png";